<template>
  <banner-template :onCancel="onCancel">
    <component v-if="bannerComponent" v-bind:is="bannerComponent" />
  </banner-template>
</template>

<script>
import { mapState } from 'vuex'
import BannerTemplate from './BannerTemplate.vue'

// Borna bug batch 1 (item 2): `MobileAppNoticeBanner` -- the install-app /
// App Store prompt -- is removed. This stays a generic banner slot (the store
// module and template are untouched); it simply has no registered component
// to render until a future banner is deliberately added.
export default {
  components: {
    BannerTemplate,
  },
  computed: {
    ...mapState({
      bannerComponent: state => state.app.banner.component,
    }),
  },
  methods: {
    onCancel() {
      this.$store.dispatch('app/banner/hide')
    },
  },
}
</script>
